var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9844C12.5437 12.9844 12.9844 12.5437 12.9844 12C12.9844 11.4563 12.5437 11.0156 12 11.0156C11.4563 11.0156 11.0156 11.4563 11.0156 12C11.0156 12.5437 11.4563 12.9844 12 12.9844Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.40625C12.5437 7.40625 12.9844 6.96553 12.9844 6.42188C12.9844 5.87822 12.5437 5.4375 12 5.4375C11.4563 5.4375 11.0156 5.87822 11.0156 6.42188C11.0156 6.96553 11.4563 7.40625 12 7.40625Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5625C12.5437 18.5625 12.9844 18.1218 12.9844 17.5781C12.9844 17.0345 12.5437 16.5938 12 16.5938C11.4563 16.5938 11.0156 17.0345 11.0156 17.5781C11.0156 18.1218 11.4563 18.5625 12 18.5625Z",
    fill: "#383733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42188 12.9844C6.96553 12.9844 7.40625 12.5437 7.40625 12C7.40625 11.4563 6.96553 11.0156 6.42188 11.0156C5.87822 11.0156 5.4375 11.4563 5.4375 12C5.4375 12.5437 5.87822 12.9844 6.42188 12.9844Z",
    fill: "#383733"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42188 7.40625C6.96553 7.40625 7.40625 6.96553 7.40625 6.42188C7.40625 5.87822 6.96553 5.4375 6.42188 5.4375C5.87822 5.4375 5.4375 5.87822 5.4375 6.42188C5.4375 6.96553 5.87822 7.40625 6.42188 7.40625Z",
    fill: "#383733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42188 18.5625C6.96553 18.5625 7.40625 18.1218 7.40625 17.5781C7.40625 17.0345 6.96553 16.5938 6.42188 16.5938C5.87822 16.5938 5.4375 17.0345 5.4375 17.5781C5.4375 18.1218 5.87822 18.5625 6.42188 18.5625Z",
    fill: "#383733"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 12.9844C18.1218 12.9844 18.5625 12.5437 18.5625 12C18.5625 11.4563 18.1218 11.0156 17.5781 11.0156C17.0345 11.0156 16.5938 11.4563 16.5938 12C16.5938 12.5437 17.0345 12.9844 17.5781 12.9844Z",
    fill: "#383733"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 7.40625C18.1218 7.40625 18.5625 6.96553 18.5625 6.42188C18.5625 5.87822 18.1218 5.4375 17.5781 5.4375C17.0345 5.4375 16.5938 5.87822 16.5938 6.42188C16.5938 6.96553 17.0345 7.40625 17.5781 7.40625Z",
    fill: "#383733"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 18.5625C18.1218 18.5625 18.5625 18.1218 18.5625 17.5781C18.5625 17.0345 18.1218 16.5938 17.5781 16.5938C17.0345 16.5938 16.5938 17.0345 16.5938 17.5781C16.5938 18.1218 17.0345 18.5625 17.5781 18.5625Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCategories);
export default __webpack_public_path__ + "static/media/allCategories.b9b31c0568ca3ba3763c7f1cf8f14b13.svg";
export { ForwardRef as ReactComponent };